// src/pages/dashboard/section-harvesting/SectionHarvesting.jsx
import React from "react";
import { Paper, Stack, Typography, Box, Grid } from "@mui/material"; // Tambahkan Box
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';

import LokasiClosingByMouth from "../../harvesting/monitor-hasil-panen/LokasiClosingByMouth";

function SectionHarvesting({ paperShadow }) {
    return (
        <Paper
            sx={{
                p: 3,
                mb: 3,
                borderRadius: 2,
                boxShadow: paperShadow,
            }}
        >
                <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 3 }}>
                    <LocalShippingOutlinedIcon sx={{ fontSize: 32, color:"#FB8C00" }} />
                    <Box>
                        <Typography variant="h6" fontWeight="bold">
                            Harvesting
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Deskripsi
                        </Typography>
                    </Box>
                </Stack>
                <Typography variant="body1" color="text.primary">
                    <Grid container spacing={12}>
                        <Grid size={12}>
                            <LokasiClosingByMouth/>
                        </Grid>
                    </Grid>
                </Typography>
        </Paper>
    );
}

export default SectionHarvesting;